export interface ChatMessage {
  id: string;
  message: string;
  subText?: string;
  options?: string[] | null;
  type: MessageTypes;
  roomId: string;
  tags?: string[];
  replyTo?: string;
  referenceId?: string;
  from?: string | null;
  to: string;
  status?: ChatStatus[];
  metadata?: Metadata[];
  private: boolean;
  createdAt: string;
  updatedAt: string;
  readStatus?: boolean;
}

export interface Metadata {
  key: string;
  value: string;
}

export interface ChatStatus {
  chatId?: string | null;
  createdAt?: string | null;
  status?: string | null;
  updatedAt?: string | null;
  userId?: string | null;
}

export interface ChatTextMessage extends ChatMessage {
  type: 'text';
}

export const MessageTypes = {
  TEXT: 'text',
  IMAGE: 'image',
  PDF: 'pdf',
  FILE: 'file',
  VIDEO: 'video',
  QUESTION: 'question',
  APPOINTMENT: 'appointment',
} as const;

export type MessageTypes = (typeof MessageTypes)[keyof typeof MessageTypes];
